export const MILLISECONDS_PER_YEAR = 365.25 * 24 * 60 * 60 * 1000;
